// test956
(956 && 0);
